import { createContext } from "react";
import { FieldValue } from "src/api/client-api/ActionPlan/ActionPlanAction/useGetFieldValues";
import { ActionPlanAction } from "src/api/client-api/ActionPlan/ActionPlanAction/useGetOneActionPlanAction";
import { GetOnePost } from "src/api/client-api/post/useGetOnePost";
import { ImpactDataSummary } from "./utils/impactData/getImpactData";

export type MyActionPlanInitialValues = {
    actionPlanAction: ActionPlanAction;
    impactDataSummary: ImpactDataSummary;

    isActionPlanActionReady: boolean;
    areQuestionsAnswered: boolean;

    isEditMode: boolean;
    setIsEditMode: (v: boolean) => void;

    startingPost: GetOnePost | undefined;
    canBeGeneralized: boolean;
    isEmpty: boolean;
    fieldValues: FieldValue[] | undefined;
    isFieldValueReady: boolean;
};
export const MyActionPlanContext = createContext<MyActionPlanInitialValues | null>(null);
